import { commaListSchema, filterDateRangeSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { BirdieSessionsList } from "@/features/birdie-monitor";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";

/**
 * Birdie's sessions. Lenient URL schema (a strict enum on a URL param crashes the page, webapp-routing.md): the
 * monitor API checks the values. singleSelect and entity chips store a scalar, multiSelect a comma list.
 */
export const Route = createFileRoute("/birdie/sessions/")({
  validateSearch: z.object({
    /** The session whose quick view (what the person saw) shows beside the list. */
    sessionId: z.string().optional().catch(undefined),
    search: z.string().optional().catch(undefined),
    sort: z.string().optional().catch(undefined),
    filters: z
      .object({
        agent: withOperators(z.string().optional()),
        channel: withOperators(z.string().optional()),
        ownerId: withOperators(z.string().optional()),
        status: withOperators(commaListSchema),
        flagged: withOperators(z.string().optional()),
        lastActivityAt: filterDateRangeSchema.catch(undefined),
      })
      .optional(),
    ...filterSearchFragment,
  }),
  component: BirdieSessionsList,
});
